"use client";

import { devSectionAttr } from "@/lib/dev/section-attr";

import { CcAkEmailForm } from "./CcAkEmailForm";
import type { AiKollenCopy } from "./ai-kollen-copy";

const CC_AI_KOLLEN_FOOTER_CLOSING_TITLE_ID = "cc-ai-kollen-footer-closing-title";

type CcAiKollenFooterClosingCtaProps = {
  copy: AiKollenCopy["email"];
  privacyHref: string;
};

/** AI-kollen email fallback in the Odysseus footer closing band (same shell as SEO). */
export function CcAiKollenFooterClosingCta({
  copy,
  privacyHref,
}: CcAiKollenFooterClosingCtaProps) {
  return (
    <section
      id={copy.id}
      className="cc-home-closing-cta cc-home-closing-cta--ai-kollen"
      aria-labelledby={CC_AI_KOLLEN_FOOTER_CLOSING_TITLE_ID}
      {...devSectionAttr("ai-kollen-footer-cta")}
    >
      <div className="cc-home-closing-cta__frame" data-cc-nav="dark">
        <div className="cc-home-closing-cta__container">
          <div className="cc-home-closing-cta__intro">
            <h2 id={CC_AI_KOLLEN_FOOTER_CLOSING_TITLE_ID} className="cc-home-closing-cta__title">
              {copy.title}
            </h2>
            <p className="cc-home-closing-cta__subtitle">{copy.intro}</p>
          </div>

          <CcAkEmailForm copy={copy} privacyHref={privacyHref} layout="closing" />
        </div>
      </div>
    </section>
  );
}
